import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { weddingConfig } from './config/weddingConfig';
import Header from './components/Header';
import Footer from './components/Footer';
import WeddingPage from './pages/WeddingPage';
import EventDetails from './pages/EventDetails';
import GuestList from './pages/GuestList';
import ExploreGoa from './pages/ExploreGoa';
import HowToGetHere from './pages/HowToGetHere';

function App() {
  // Set page title and favicon from config
  React.useEffect(() => {
    document.title = weddingConfig.page.title;
    
    // Update or create favicon link
    let favicon = document.querySelector("link[rel='icon']");
    if (!favicon) {
      favicon = document.createElement('link');
      favicon.rel = 'icon';
      document.head.appendChild(favicon);
    }
    favicon.type = 'image/png';
    favicon.href = weddingConfig.page.favicon;
  }, []);

  // Set CSS variable for background image and blur from config
  // Files in public folder are served at root, so paths starting with / work directly
  const bgPatternStyle = {
    fontFamily: weddingConfig.design.fonts.body,
    '--bg-pattern': `url("${weddingConfig.design.images.background}")`,
    '--bg-blur': weddingConfig.design.images.backgroundBlur || '0px',
    '--bg-opacity': weddingConfig.design.backgroundOpacity || 0.85
  };

  return (
    <Router>
      <div className="App" style={bgPatternStyle}>
        <Header config={weddingConfig} />
        <Routes>
          <Route path="/" element={<WeddingPage />} />
          <Route path="/story" element={<WeddingPage />} />
          <Route path="/schedule" element={<WeddingPage />} />
          <Route path="/rsvp" element={<WeddingPage />} />
          <Route path="/accommodations" element={<WeddingPage />} />
          <Route path="/event/:eventSlug" element={<EventDetails />} />
          <Route path="/guest-list" element={<GuestList />} />
          <Route path="/explore-goa" element={<ExploreGoa />} />
          <Route path="/how-to-get-here" element={<HowToGetHere />} />
        </Routes>
        <Footer config={weddingConfig} />
      </div>
    </Router>
  );
}

export default App;

